import { gql } from "@apollo/client";

import { OrganizationMemberFragment } from "./get-organization-members-query";

export default gql`
  ${OrganizationMemberFragment}
  query getOrganizationMemberQuery($organizationId: Int!, $userId: Int!) {
    organization(pk: $organizationId) {
      id
      members(userId: $userId, first: 1) {
        edges {
          node {
            ...OrganizationMember
          }
        }
      }
    }
  }
`;
